export const ro = {
    seo: {
        title: 'MyCarCosts | Ultimate Car Expense Tracker & Repair Analysis',
        description: 'Track car maintenance, expenses, and history. Use our AI-powered repair vs sell analyzer to make data-driven decisions about your vehicle.'
    },
    common: {
        back: "Înapoi",
        save: "Salvează",
        saved: "Salvat",
        cancel: "Anulează",
        close: "Închide",
        accessDenied: "Acces Interzis",
        noExportPermission: "Nu aveți permisiunea de a exporta aceste date ale mașinii.",
        delete: "Șterge",
        downgrade: "Reducere",
        downgradeConfirm: "Sunteți sigur că doriți să treceți la planul Gratuit?",
        edit: "Editează",
        loading: "Se încarcă...",
        confirm: "Confirmă",
        processing: "Se procesează...",
        history: "Istoric",
        currentCar: "Mașina Curentă",
        purchasedCarTitle: "Achiziția Mașinii",
        initialCost: "Cost Inițial",
        done: "Finalizat",
        ok: "OK",
        error: "Eroare",
        errorSaving: "Eroare la salvarea datelor",
        mandatoryFieldsError: "Vă rugăm să completați toate câmpurile obligatorii corect.",
        search: "Caută",
        milesShort: "mi",
        kmShort: "km",
        invalidEmail: "Format de email invalid",
        today: "Astăzi",
        car: "Mașină",
        all: "Toate",
        deleteConfirm: "Șterge",
        unsavedChangesTitle: "Modificări Nesalvate",
        unsavedChangesMessage: "Vrei să salvezi modificările înainte de a pleca?",
        dontSave: "Nu salva",
        additionalOptions: "Opțiuni suplimentare",
        add: "Adaugă",
        fileTooLarge: "Fișierul este prea mare. Dimensiunea maximă este {limit} MB.",
        storageFull: "Limita de stocare a fost depășită. Stocarea maximă este {limit} MB.",
        dailyUploadLimit: "Limita zilnică de încărcare a fost atinsă ({limit} fișiere/zi). Încearcă din nou mâine.",
        hourlyUploadLimit: "Limita orară de încărcare a fost atinsă ({limit} fișiere/oră). Încearcă din nou în o oră.",
        fileCountLimit: "Maxim {limit} fișiere permise pe element.",
        emailParseLimitReached: "Limita de analiză a emailurilor a fost atinsă. Te rugăm să îți upgradezi planul sau să procesezi manual.",
        emailLimitText: "Limita de procesare a emailurilor a fost atinsă.",
        monthlyEmailScans: "Scanări Email Lunare",
        lifetimeEmailScans: "Scanări Email pe Viață",
        monthlyFileScans: "Scanări Lunare de Chitanțe",
        lifetimeFileScans: "Scanări de Chitanțe pe Viață",
        fileLimitText: "Limita de scanare a chitanțelor a fost atinsă.",
        planFreeTier: "Plan Gratuit",
        planProTier: "Plan Pro",
        uploadFailed: "Încărcarea a eșuat",
        attachments: "Atașamente",
        limitsAndUsage: "Limite și Utilizare",
        addresses: "adrese",
        emailCopied: "Adresa de email a fost copiată!",
        units: {
            liters: "l",
            gallons: "gal",
            kilometers: "km",
            miles: "mi",
        },
        included: "Inclus",
        proOnly: "Numai PRO",
        month: "lună",
        openInNewTab: "Deschide în tab nou",
        menu: "Meniu",
        home: "Acasă",
        monthsShort: {
            0: "Ian",
            1: "Feb",
            2: "Mar",
            3: "Apr",
            4: "Mai",
            5: "Iun",
            6: "Iul",
            7: "Aug",
            8: "Sep",
            9: "Oct",
            10: "Nov",
            11: "Dec",
        },
    },
    carMetadata: {
        bodyType: "Tip Caroserie",
        drivetrain: "Transmisie",
        transmission: "Cutie de Viteză",
        bodyTypes: {
            sedan: "Sedan",
            hatchback: "Hatchback",
            wagon: "Wagon (Estate)",
            suv: "SUV",
            crossover: "Crossover",
            coupe: "Coupe",
            convertible: "Cabriolet",
            pickup: "Pickup",
            van: "Van / Minivan",
            commercial: "Commercial",
            other: "Altul",
            not_specified: "-",
        },
        drivetrains: {
            not_specified: "-",
            fwd: "FWD",
            rwd: "RWD",
            awd: "AWD / 4x4",
            other: "Altul",
        },
        transmissions: {
            not_specified: "-",
            manual: "Manual",
            automatic: "Automat",
            cvt: "CVT",
            other: "Altul",
        },
        otherLabel: "Altul (specificați)",
        mileageLabel: "Kilometraj",
    },
    auth: {
        welcome: "Bine ai venit",
        welcomeBack: "Bine ai revenit",
        signIn: "Conectează-te",
        signInWithGoogle: "Conectează-te cu Google",
        signOut: "Deconectează-te",
        magicLinkDesc: "Primește un link magic în emailul tău",
        magicLinkSent: "Linkul magic a fost trimis!",
        magicLinkCheckEmail: "Verifică-ți emailul și dă clic pe link pentru a te conecta.",
        emailAddress: "Adresă de Email",
        getMagicLink: "Obține Linkul Magic",
        sending: "Se trimite...",
        linkSent: "Link trimis",
        orContinueWith: "Sau continuă cu",
        googleAccount: "Cont Google",
        newUserNote: "Ești nou aici? Contul tău va fi creat automat la prima conectare reușită.",
        magicLinkError: "Nu s-a putut trimite linkul magic. Te rugăm să verifici emailul și să încerci din nou.",
        genericError: "A apărut o eroare. Te rugăm să încerci din nou.",
        projectDescription: "Urmărește costurile, întreținerea și istoricul mașinii tale într-un singur loc.",
        loginError: "Imposibil de conectat",
        loggingIn: "Se conectează...",
        authenticating: "Se autentifică...",
        authenticatingDesc: "Te rugăm să aștepți în timp ce securizăm sesiunea ta.",
    },
    settings: {
        title: "Setări",
        systemPreferences: "Preferințe de Sistem",
        appSettings: "Setări Aplicație",
        dangerZone: "Zona de Risc",
        theme: "Temă",
        language: "Limba Interfeței",
        currency: "Monedă",
        units: "Unități",
        distanceUnit: "Unitate de distanță",
        volumeUnit: "Unitate de volum",
        expenseTypes: "Tipuri de cheltuieli",
        expenseTypesDesc: "Gestionați categoriile",
        categories: "Categorii",
        exportData: "Exportați datele",
        exportDesc: "Descărcați CSV complet",
        importData: "Importați datele",
        importDesc: "Restaurare din backup CSV",
        deleteAccount: "Ștergeți contul",
        deleteAccountDesc: "Eliminați permanent toate datele",
        enableSync: "Activați sincronizarea",
        enableSyncDesc: "Sincronizați datele între dispozitive",
        account: "Cont",
        accountPlan: "Plan de cont",
        carsUsage: "Mașini",
        carsLimitReached: "Limita de mașini atinsă",
        storageSize: "Dimensiune stocare",
        emailScans: "Scanări email",
        fileScans: "Scanări chitanțe",
        plans: "Planuri",
        currentlyPlan: "În prezent",
        upgradePlan: "Upgrade",
        manageSubscription: "Gestionați abonamentul",
        nextPayment: "Următoarea plată",
        endsOn: "Se termină pe",
        adminConsole: "Consola de administrare",
        systemControl: "Control sistem",
        customCategories: "Categorii și etichete personalizate",
        interfaceTheme: "Tema interfeței",
        light: "Deschis",
        dark: "Întunecat",
        timezone: "Fus orar",
        timezoneDesc: "Utilizat pentru mementouri programate prin email",
        timeFormat: "Format orar",
        timeFormat24h: "24 de ore (14:30)",
        timeFormat12h: "12 de ore (2:30 PM)",
        kilometers: "kilometri (km)",
        miles: "mile (mi)",
        liters: "litri (l)",
        gallons: "galoane (gal)",
        accountManagement: "Gestionarea contului",
        contactUs: "Contactați-ne",
        contactDesc: "Pentru sugestii, cereri de funcții și întrebări",
        logOut: "Deconectare",
        logOutConfirmTitle: "Deconectare",
        logOutConfirmMessage: "Sunteți sigur că doriți să vă deconectați din cont?",
        keepAccount: "Păstrați contul",
        deleteAccountConfirmTitle: "Ștergeți contul",
        deleteAccountConfirmMessage: "Sunteți sigur că doriți să ștergeți permanent contul și toate datele asociate mașinilor? Această acțiune nu poate fi anulată.",
        deletePermanently: "Ștergeți permanent",
        deleting: "Șterg...",
        contactSupport: "Contactați suportul",
        messageSent: "Mesaj trimis!",
        feedbackThanks: "Vă mulțumim pentru feedback. Apreciem contribuția dumneavoastră și ne vom ocupa de ea.",
        backToSettings: "Înapoi la setări",
        subjectLabel: "Subiect",
        messageLabel: "Mesaj",
        subjectPlaceholder: "Despre ce este vorba?",
        messagePlaceholder: "Spuneți-ne despre sugestia, cererea de funcții sau întrebarea dumneavoastră...",
        enterSubjectAlert: "Vă rugăm să introduceți un subiect",
        enterMessageAlert: "Vă rugăm să introduceți un mesaj",
        sendFailedAlert: "Nu s-a reușit trimiterea mesajului. Vă rugăm să încercați din nou mai târziu.",
    },
    export: {
        title: "Exportați datele",
        generatePDF: "Generați PDF",
        carInformation: "Informații despre mașină",
        editInfo: "Editați informațiile de mai jos pentru a personaliza exportul",
        editInfoHint: "Puteți elimina sau modifica orice câmpuri pe care nu doriți să le includeți",
        filters: "Filtre",
        expenseTypes: "Tipuri de cheltuieli",
        includeNotes: "Includeți note",
        includeImages: "Includeți fișiere",
        hideDisabled: "Ascundeți elementele dezactivate",
        itemsCount: "{total} elemente, {selected} selectate",
        selectAll: "Selectați tot",
        deselectAll: "Deselecționați tot",
        expenses: "Cheltuieli",
        notes: "Note",
        spareParts: "Piese de schimb",
        images: "Imagini",
        files: "Fișiere",
        summary: "Sumar",
        totalExpenses: "Cheltuieli totale",
        totalItems: "Total elemente",
        generatedOn: "Generat pe",
        noItemsSelected: "Niciun element selectat pentru export",
        noItemsAvailable: "Niciun element disponibil pentru export",
        generating: "Generare PDF...",
        downloadPDF: "Descărcați PDF",
        pdfFileName: "{carName}_export_{date}.pdf",
        reportTitle: "Raport de cheltuieli auto",
        exportButton: "Exporta",
        generateCSV: "Generați CSV",
        formatSelectorTitle: "Selectați formatul",
        formatSelectorMsg: "Vă rugăm să selectați formatul de export",
        proFeatureExportTitle: "Funcție Pro: Exportă Date",
        proFeatureExportDesc: "Treceți la PRO pentru a exporta istoricul mașinii în PDF.",
        exportRestrictedPopup: "Exportul de date este disponibil doar pentru utilizatorii Pro.",
        allTypes: "Toate tipurile",
        statistics: "Statistici",
        driven: "Conduse",
        since: "Din",
        averageCost: "Cost mediu",
        perKm: "pe km",
        perMile: "pe milă",
        period: "Perioadă",
        dateFrom: "De la",
        dateTo: "Până la",
        allTime: "Ștergeți filtrul",
        periodHint: "Dacă nu este selectată nicio perioadă — toate cheltuielile sunt afișate",
        noExpenses: "Niciun cheltuială nu se potrivește cu filtrele",
        expensesSection: "Cheltuieli",
        attachmentsSection: "Atașamente",
        imagesCount: "{count} imagini",
        pdfsCount: "{count} PDF-uri",
        includeParts: "Include piese de schimb",
        pageLabel: "Pagina",
    },
    expenses: {
        title: "Cheltuieli",
        newExpense: "Cheltuială nouă",
        editExpense: "Editează cheltuiala",
        openExpense: "Deschide înregistrarea cheltuielii",
        details: "Detalii cheltuială",
        selectType: "Selectează tipul",
        selectTypePlaceholder: "Selectează tipul cheltuielii...",
        shortDescriptionPlaceholder: "Descriere scurtă...",
        expenseTitle: "Titlu",
        logEntryTitleLabel: "Titlul înregistrării (Opțional)",
        defaultTitlePlaceholder: "Titlu implicit - {type}",
        autoTitlePlaceholder: "Va fi completat automat pe baza tipurilor selectate",
        carDataTitle: "Datele Mașinii",
        defaultTitlePrefix: "Titlul implicit va fi -",
        addAnother: "Adaugă un alt tip de cheltuială",
        addAnotherHint: "Dacă această înregistrare include mai multe tipuri de cheltuieli, le poți adăuga pe toate aici pentru a asigura statistici precise.",
        carValueDescription: "Valoarea de piață estimată a mașinii în acest moment.",
        type: "Tip",
        date: "Dată",
        amount: "Sumă",
        totalAmount: "Total",
        splitCosts: "Împărțiți costurile?",
        combineCosts: "Combinați costurile",
        amountWork: "Lucrări",
        amountParts: "Piese",
        mileage: "Kilometraj",
        carValue: "Valoarea mașinii",
        description: "Descriere",
        detailedDescription: "Descriere detaliată",
        electricity: "Electricitate",
        fuelType: "Tip combustibil",
        fuelTypeOptions: {
            petrol: "Benzină",
            diesel: "Motorină",
            lpg: "LPG",
            electricity: "Electricitate",
        },
        carData: "Date despre mașină",
        images: "Fișiere",
        addImages: "Adaugă fișiere",
        addImagesPDFs: "Adaugă imagini sau PDF-uri",
        deleteExpense: "Șterge cheltuiala",
        deleteConfirm: "Ești sigur că vrei să ștergi această cheltuială?",
        saveSuccess: "Cheltuiala a fost salvată cu succes",
        thisExpense: "Această cheltuială",
        stats: {
            annual: "Anual",
            allTime: "De-a lungul timpului",
            avgMonth: "Medie/Lună",
            costPer: "Cost/",
            noExpenses: "Încă nu sunt cheltuieli",
            dragToReorder: "Trage pentru a reordona",
        },
        expensesFound: "Creata",
        noExpensesFound: "Nu au fost găsite cheltuieli.",
        noDescription: "Fără descriere",
        imagesCount: "Imagini ({count})",
        deleteImageTitle: "Șterge imaginea",
        deleteImageConfirm: "Ești sigur că vrei să ștergi această imagine? Această acțiune nu poate fi anulată.",
        typeLabels: {
            fuel: "Combustibil",
            car_wash: "Spălare",
            repairs: "Reparații",
            maintenance: "Întreținere",
            parts: "Piese de schimb",
            insurance: "Asigurare",
            inspection: "Inspecție",
            tyres: "Anvelope",
            parking: "Parcare",
            electricity: "Electricitate",
            taxes: "Impozite",
            other: "Altele",
            info: "Informații",
            service_maintenance: "Întreținere",
            service_repair: "Reparare",
            service_tuning: "Tuning",
        },
        serviceGroup: {
            name: "Serviciu",
            selectSubtype: "Selectează tipul de serviciu",
            maintenance: "Întreținere",
            repair: "Reparare",
            tuning: "Tuning",
        },
    },
    repeatingExpenses: {
        title: "Cheltuială Repetitivă",
        repeatToggle: "Repetă această cheltuială",
        repeatFrequency: "Frecvență",
        monthly: "Lunar",
        startDate: "Data de Începere",
        nextDate: "Următoarea înregistrare va fi generată",
        endDate: "Data de Încheiere",
        noEndDate: "Fără dată de încheiere",
        copyOptions: "Opțiuni de Copiere",
        copyTitle: "Copiază titlul înregistrării",
        copyLocation: "Copiază locația",
        copyDescription: "Copiază descrierea",
        active: "Activ",
        status: "Status",
        managedByRepeat: "Această cheltuială face parte dintr-o secvență repetitivă.",
        placeholder: "Aici poți configura repetarea automată pentru această cheltuială dacă apare regulat cu aceeași sumă.",
        deleteRepeat: "Șterge Repetiția",
        deleteRepeatConfirm: "Ești sigur că vrei să oprești și să ștergi această secvență repetitivă? Înregistrările viitoare nu vor fi generate. Înregistrările anterioare vor rămâne.",
        relatedEntries: "Înregistrări în această secvență",
        stopRepeat: "Oprește repetarea",
        isRepeating: "Repetitiv",
        noTerm: "Nedefinit",
        until: "Ultima înregistrare va fi generată",
        summaryCopy: "Sistemul va copia",
        simulate: "Simulează generarea următoarei înregistrări",
        simulateSuccess: "Generarea următoarei înregistrări a fost simulată cu succes",
        simulateNoDate: "Nu mai sunt date de generat (data finală atinsă)",
    },
    onboarding: {
        title: "Configurare profil",
        welcome: "Bine ai venit!",
        subtitle: "Personalizează-ți experiența de condus.",
        currency: "Monedă",
        preferredCurrency: "Moneda preferată",
        distUnit: "Unitate de distanță",
        volUnit: "Unitate de volum",
        complete: "Finalizează configurarea",
    },
    cars: {
        unitChangeWarningTitle: "Atenție la schimbarea unității",
        unitChangeWarningMessage: "Schimbarea acestor unități nu va converti datele existente. Toate înregistrările istorice vor rămâne exact așa cum au fost introduse.",
        unitChangeWarningConfirm: "Înțeles",
        title: "Garaj",
        carAdmins: "Administratori auto",
        sharedWithMe: "Partajat cu mine",
        manageAdmins: "Gestionează administratorii",
        adminEmail: "Email administrator",
        addAdmin: "Adaugă administrator",
        addAdminPlaceholder: "de ex. prieten@email.com",
        removeAdmin: "Șterge",
        removeAdminConfirm: "Ești sigur că vrei să ștergi acest administrator?",
        adminAdded: "Administrator adăugat",
        adminRemoved: "Administrator șters",
        removeMyAccess: "Șterge accesul meu",
        removeMyAccessConfirm: "Ești sigur că vrei să renunți la accesul la această mașină?",
        myAccessRemoved: "Accesul a fost șters",
        noAdminsYet: "Nu au fost adăugați administratori încă.",
        adminInfoText: "Administratorii pot adăuga și edita cheltuieli, note și piese de schimb, dar nu pot șterge mașina în sine.",
        newCar: "Adaugă Mașină",
        carNotFound: "Mașina Nu A Fost Găsită",
        carNotFoundDesc: "Mașina solicitată nu există sau nu ai acces.",
        accessDenied: "Acces Refuzat",
        accessDeniedDesc: "Această mașină este privată și nu este disponibilă public.",
        backToHome: "Înapoi la Acasă",
        adminRestricted: "Acces Restricționat",
        adminRestrictedDesc: "Numai administratorii autorizați pot accesa această consolă. Te rugăm să te întorci la aplicația principală.",
        returnHome: "Întoarce-te Acasă",
        editCar: "Editează Mașina",
        name: "Numele Mașinii",
        model: "Model",
        year: "An",
        plate: "Numărul de Înmatriculare",
        vin: "Numărul VIN",
        mileage: "Kilometraj Curent",
        initialMileage: "Kilometraj Inițial",
        engineType: "Tip Motor",
        tapToChangeIcon: "Apasă pentru a schimba iconița",
        chooseIcon: "Alege Iconița",
        imageTab: "Imagine",
        iconTab: "Iconiță",
        chooseColor: "Alege Culoarea",
        chooseEmoji: "Alege Emoji",
        uploadImage: "Încarcă Imagine",
        clickToBrowse: "Apasă pentru a răsfoi fișierele",
        currentCarIcon: "Iconița mașinii curente",
        changeImage: "Schimbă Imaginea",
        zoom: "Zoom",
        rotate: "Rotește",
        removeChangeImage: "Șterge / Schimbă Imaginea",
        selectIcon: "Selectează Iconița",
        cropAndSave: "Decupează & Salvează",
        displayName: "Nume Afișat",
        displayNamePlaceholder: "de ex. Mașina Mea de Weekend",
        makeLabel: "Marcă *",
        modelLabel: "Model *",
        yearLabel: "An *",
        fuelTypeLabel: "Tip *",
        licensePlateLabel: "Număr de Înmatriculare",
        vinLabel: "VIN",
        notesLabel: "Note",
        notesPlaceholder: "de ex. 1.6 TDI, 85kW, 1588cc, baterie 62kWh, AWD, etc.",
        publicAccess: "Fă mașina accesibilă public",
        publicAccessDesc: "Alții pot vizualiza această mașină prin linkul partajat",
        shareLocations: "Permiteți vizualizarea locațiilor adăugate",
        shareLocationsDesc: "Activați aceasta pentru a face locațiile mașinii vizibile în vizualizarea publică",
        deleteCar: "Șterge Mașina",
        deleteCarTitle: "Șterge Mașina",
        deleteCarConfirm: "Ești sigur că vrei să ștergi '{name}'? Această acțiune nu poate fi anulată.",
        noCars: "Nu există mașini în garajul tău",
        addFirstCarNote: "Începe-ți călătoria adăugând primul tău vehicul pentru a urmări cheltuielile.",
        addVehicle: "Adaugă Un Vehicul",
        myVehicles: "Vehiculele Mele",
        favorites: "Preferate",
        deleteConfirm: "Ești sigur că vrei să ștergi această mașină? Toate cheltuielile asociate vor fi șterse.",
        deleteFailed: "Ștergerea mașinii a eșuat",
        saveFailed: "Salvarea datelor mașinii a eșuat",
        adminActions: "Acțiuni Admin",
        importCsv: "Importă CSV",
        clearData: "Șterge Datele",
        distanceUnitLabel: "Unitate de Distanță",
        volumeUnitLabel: "Unitate de Volum",
        currencyLabel: "Monedă",
        boughtAt: "Data Achiziției",
        purchasePrice: "Preț de Achiziție",
        purchaseMileage: "Kilometraj la Achiziție",
        createPurchaseRecord: "Creează automat un istoric de achiziție",
        makePlaceholder: "de ex. BMW",
        modelPlaceholder: "de ex. X5",
        platePlaceholder: "de ex. AB-1234",
        vinPlaceholder: "VIN...",
        purchaseInfoNote: "Această informație va crea un record inițial 'Informații' în istoricul tău cu datele specificate.",
        availableTypes: "Tipuri Disponibile",
        dragToReorder: "Trage pentru a reordona",
        requestTypeNote: "Dacă ai nevoie de alt tip - ",
        requestTypeAction: "anunță-ne!",
        emailProcessingTitle: "Procesare Email",
        emailInstructions: "Trimite chitanțele tale la adresa de mai jos. Vom extrage datele și vom crea cheltuieli automat.",
        recentEmails: "Emailuri Primite",
        viewAllEmails: "VEZI TOATE ({count})",
        noEmailsReceived: "Nu au fost primite emailuri încă.",
        analysisResult: "Rezultatul Analizei",
        vehicleInfo: "Informații Vehicul",
        preferences: "Preferințe",
        purchaseHistory: "Istoricul Achizițiilor",
        emailProcessing: "Procesare Email",
        publicAccessTitle: "Acces Public",
        expenseTypesTitle: "Tipuri de Cheltuieli",
        adminActionsTitle: "Acțiuni Admin",
        enterPurchaseDateAlert: "Te rugăm să introduci data achiziției",
        allowedSenderEmails: "Emailuri Expeditori Permise",
        allowedEmailsDesc: "Adaugă adrese de email care sunt permise să trimită chitanțe pentru această mașină. Maxim 5 adrese.",
        noAllowedEmails: "Nu au fost adăugate emailuri permise.",
        emailAlreadyAdded: "Această adresă de email este deja permisă pentru această mașină.",
        maxAllowedEmailsReached: "Limita maximă de emailuri permise a fost atinsă.",
        addAllowedEmailPlaceholder: "Adaugă email permis...",
        ownerEmail: "Proprietar",
        onlyOwner: "numai proprietar",
        defaultAllowed: "Întotdeauna permis",
        carLimitReachedTitle: "Limită de Mașini Atinge",
        carLimitReachedMessage: "Planul tău {plan} permite {limit} mașină(i). Ai deja {current}. Mergi la setări pentru a vedea limitele tale sau contactează-ne pentru a face upgrade.",
        carLimitGoToSettings: "Mergi la Setări",
        archivedCars: "Arhivate",
        archiveCar: "Arhivează Mașina",
        unarchiveCar: "Dezarhivează Mașina",
        sellDate: "Data Vânzării",
        sellPrice: "Prețul Vânzării",
        sellMileage: "Kilometrajul Vânzării",
        archiveConfirm: "Ești sigur că vrei să arhivezi această mașină?",
        archiveInstructions: "Arhivarea unei mașini înseamnă că nu mai este a ta sau că nu o mai întreții. Te rugăm să oferi detaliile vânzării pentru statistici. Aceasta va face ca mașina să fie doar în citire. Câmpurile de mai jos pot fi editate ulterior.",
        archivedBadge: "Arhivat",
        saleDetails: "Detalii Vânzare",
        saleDetailsNote: "Detaliile vânzării sunt folosite pentru statistici. Le poți actualiza dacă este necesar.",
        archiveDetailsNotFillable: "Te rog să completezi toate câmpurile pentru a arhiva mașina",
        emailAddressWillBeAvailableAfterSave: "Adresa de email va fi disponibilă după salvarea mașinii.",
        proFeatureAdminTitle: "Funcție Pro: Administratori ai Mașinii",
        proFeatureAdminDesc: "Adăugați alți utilizatori care pot vizualiza și gestiona aceste date ale mașinii.",
        proFeatureEmailTitle: "Funcție Pro: Expeditori suplimentari",
        proFeatureEmailDesc: "Adăugați alte adrese de email permise din care pot fi trimise chitanțele pentru această mașină.",
        estimatedMileage: "Kilometraj estimat",
        summaryFrequencyLabel: "Frecvența rezumatului",
        summaryFrequencyOptions: {
            none: "Dezactivat",
            monthly: "Lunar",
            semiAnnually: "Semestrial",
            annually: "Anual",
        },
        healthProfilePrompt: "Completează-ți profilul de sănătate pentru o analiză precisă!",
    },
    fuelTypes: {
        not_specified: "-",
        petrol: "Benzină",
        diesel: "Motorină",
        hybrid: "Hibrid",
        electric: "Electric",
        lpg: "LPG",
    },
    statistics: {
        mileageTrend: "Tendința de kilometraj",
        title: "Statistici",
        allYears: "Toate anii",
        totalSpent: "Total Cheltuit",
        spentIn: "Cheltuit în {year}",
        perMonth: "pe lună",
        overall: "în total",
        vsPrev12m: "vs 12l prec.",
        rolling12m: "Ultimele 12l",
        byType: "Pe Tip",
        byMonth: "Pe Lună",
        byYear: "Pe An",
        noData: "Nu sunt date pentru acest an",
        mostExpensive: "Cea mai scumpă",
        top: "Top",
        untitled: "Fără Titlu",
        assetAnalysis: "Analiza Valorii & Costurilor",
        burnNote: "* 'Total Cheltuieli' include atât banii cheltuiți, cât și estimarea scăderii valorii mașinii.",
        carMarketValue: "Valoarea de Piață a Mașinii",
        cumulativeCosts: "Costuri Cumulative",
        totalBurn: "Total Cheltuieli (Costuri + Depr)",
        entries: "înregistrări",
        avgPrice: "Preț Mediu",
        consumption: "Consum",
        price: "Preț",
        fuelPriceTrend: "Tendința Prețului Combustibilului",
        spendingTrend: "Tendința cheltuielilor",
        costPerKmTrend: "Cost pe 1 km",
        costPerMileTrend: "Cost pe 1 milă",
        serviceTrendsTitle: "Tendințe în Servicii",
        expensesOnMap: "Cheltuieli pe Hartă",
        visitsCountLabel: "vizite",
        locationsSummary: "Rezumat Locații",
        locationsCountLabel: "locații",
        noLocationsFoundTitle: "Nu sunt locații încă",
        noLocationsFoundDesc: "Adaugă locații în înregistrările tale pentru a le vedea pe hartă.",
        addMileageData: "Adăugați kilometraj",
        missingMileageInfo: "Nu sunt suficiente date pentru a calcula costul pe distanță. Adăugați cel puțin 2 citiri de kilometraj în această perioadă (sau una înainte de această perioadă).",
        mileageModal: {
            title: "Adăugați Kilometrajul Lipsă",
            description: "Pentru a calcula cu exactitate costurile pe distanță pentru {year}, trebuie să știm kilometrajul la începutul și sfârșitul anului.",
            startOfYear: "Începutul anului (1 Ian)",
            endOfYear: "Sfârșitul anului (31 Dec)",
            currentMileage: "Kilometraj curent",
            placeholder: "Introduceți kilometrajul...",
            save: "Salvați Datele",
            foundNearby: "Găsit în apropiere ({date}): {value} {unit}",
            useExisting: "Folosiți aceasta",
        },
        proAnalysis: "Analiză Pro",
        detailedAnalysis: "Analiză Detaliată",
        upgradeToSee: "Upgrade pentru a vedea →",
    },
    tabs: {
        dashboard: "Tabloul de Bord",
        expenses: "Cheltuieli",
        stats: "Statistici",
        locations: "Locații",
        gallery: "Fișiere",
        parts: "Piese",
        notes: "Note",
        repair: "Mod Reparare",
        'repair-switch': "Comutator Auto",
    },
    repairAnalysis: {
        title: "Analiza Deciziei de Reparare",
        ownershipLength: "Durata de Proprietate",
        currentValue: "Valoare Curentă",
        valueOutdated: "Valoarea poate fi depășită",
        addValueToEnable: "Adaugă valoarea curentă a mașinii pentru a activa analiza",
        totalInvested: "Total Investit",
        totalInvestedSub: "Preț de achiziție + reparații",
        totalExcludesFuel: "excluzând combustibilul / electricitatea",
        fuelLabelFuelOnly: "Total combustibil",
        fuelLabelEnergyOnly: "Total energie",
        fuelLabelHybrid: "Total combustibil & energie",
        fuelTypeFuel: "combustibil",
        fuelTypeEnergy: "electricitate",
        fuelTypeHybrid: "combustibil & electricitate",
        fuelTotalLabel: "Total Combustibil/Energie:",
        projectionMode: "Mod Proiecție",
        projectionModes: {
            lastYear: "Pe baza anului trecut",
            average: "Medie istorică",
            trend: "Tendință (lineară)",
        },
        brakeAssumption: "Întreținerea include estimarea ciclului de frână de 3 ani",
        repairBuffer: "Include buffer de risc de reparație bazat pe vârstă",
        yearLabel: "an",
        totalInvestedDesc: "Preț de achiziție + toate reparațiile",
        repairToValue: "Reparație la Valoare (12m)",
        repairToValueExplain: "Reparații €{cost} vs valoarea mașinii €{value}. Sub 20% este sănătos; peste 50% este risc ridicat.",
        ownershipPressure: "Presiunea Proprietății",
        ownershipPressureExplain: "Presiunea totală a costurilor: reparații €{cost} + pierdere de valoare vs €{value}. Peste 35% semnalează stres financiar.",
        investmentGap: "Diferența de Investiție",
        investmentGapExplain: "Total investit €{invested} minus valoarea curentă €{value}. Aceasta arată cât ai 'pierdut' pe proprietate până acum.",
        investmentGapDesc: "Total investit - valoare curentă",
        repairExpenses12m: "Cost de Reparare 12m",
        calculatedYearlyMileage: "Kilometraj anual calculat: {km} km",
        calculatedYearlyRepairs: "Reparații anuale calculate: {amount}",
        set: "Setează",
        plannedRepairCost: "Costul de reparare planificat",
        whatIfTitle: "Ce se întâmplă dacă cheltuiești {amount} acum?",
        updatedScore: "Scor Actualizat",
        updatedVerdict: "Verdict Actualizat",
        howIsItCalculated: "Cum este calculat acest lucru?",
        usedLifespan: "Utilizat: {usage}% din durata de viață așteptată",
        remainingLifespan: "Rămâne: ~{km} km",
        estimatedLifespan: "Durata de viață estimată: {km} km",
        lifecycle_stage_early: "Ciclul de viață devreme – risc scăzut de defecțiuni majore",
        lifecycle_stage_mid: "Ciclul de viață mediu – uzură normală",
        lifecycle_stage_late: "Ciclul de viață târziu – risc crescut de reparații",
        lifecycle_stage_end: "Sfârșitul duratei de viață așteptate – risc ridicat de reparații majore",
        calculationExplanation: "Analiza folosește prețul de achiziție al vehiculului tău, costurile recente de reparație și valoarea curentă estimată pentru a calcula un scor de sănătate financiară. Costurile mari de reparație în raport cu valoarea mașinii sau deprecierea rapidă vor scădea scorul.",
        confidenceLabel: "Încredere",
        confidenceLevel: {
            high: "Ridicată",
            medium: "Medie",
            low: "Scăzută",
        },
        mentalFactorsTitle: "Îmbunătățește acuratețea cu experiența ta",
        mentalFactorsCTA: "Verificare rapidă (30 sec)",
        mentalFactorsSurveyTitle: "Experiența Ta",
        mentalFactorsSurveyDesc: "Răspunde la 3 întrebări rapide pentru a personaliza scorul tău.",
        q1: "Îndeplinește mașina ta nevoile tale?",
        q1Help: "Spațiu, confort, caracteristici",
        q2: "Îți face plăcere să conduci mașina ta?",
        q2Help: "Aspect, confort, senzație",
        q3: "Îți faci griji cu privire la defecțiuni neașteptate?",
        q3Help: "Îngrijorări legate de fiabilitate",
        q4: "Este această mașină pentru familie și călătorii lungi?",
        q4Help: "Prioritate pentru siguranță și fiabilitate",
        factorsTitle: "Factori de Scor",
        factorsDesc: "Vezi ce influențează scorul tău",
        newCarComparison: "Compararea Mașinilor Noi",
        newCarComparisonDesc: "Compară costul tău lunar actual cu achiziționarea unei mașini noi.",
        modeLeasing: "Leasing",
        modeFullPrice: "Preț Integral",
        downPayment: "Avans",
        leaseYears: "Durată (Ani)",
        monthlyPayment: "Plată Lunară",
        carPrice: "Preț Integral al Mașinii",
        ownershipYears: "Proprietate Planificată (Ani)",
        insuranceMonthly: "CASCO / Asigurare Lunară",
        currentMonthlyCost: "Cost Auto Actual",
        newCarMonthlyCost: "Cost Mașină Nouă",
        newCarCheaper: "Mașina nouă este mai ieftină cu: {amount} / lună",
        newCarMoreExpensive: "Mașina nouă este mai scumpă cu: {amount} / lună",
        newCarSameCost: "Costurile sunt exact aceleași.",
        advancedSettings: "Setări Avansate",
        yearlyMaint: "Întreținere Anuală (€)",
        tyres3Yrs: "Anvelope / 3 ani (€)",
        depreciation5Yrs: "Depreciere (5 ani %)",
        newCarYear: "Anul Mașinii Noi",
        cumulativeCosts: "Costuri Cumulative (Proiecție)",
        comparisonByYear: "Comparare pe Ani",
        currentCarLabel: "Mașina Actuală",
        newCarLabel: "Mașina Nouă",
        resaleValue: "Valoare de Revânzare",
        startupCosts: "Costuri de Începere (Mașină Second Hand)",
        inspection: "Inspecție pre-purchase",
        initialMaintenance: "Întreținere inițială + uleiuri",
        registration: "Înregistrare / Taxe",
        total: "Total",
        currentCarTitle: "Mașina Curentă",
        newCarTitle: "Mașina Potențială",
        upfrontInvestment: "Investiție Inițială",
        monthlyReality: "Cost Lunar Real",
        depreciationShort: "Depreciere",
        howCalculated: "Cum este calculat acest lucru?",
        deltaMonthly: "Diferența lunară",
        deltaUpfront: "Diferența inițială",
        surveyMeanings: {
            practical: {
                1: "Deloc",
                2: "Se potrivește slab",
                3: "Medie",
                4: "Se potrivește bine",
                5: "Se potrivește perfect",
            },
            joy: {
                1: "Frustrant",
                2: "Plictisitor",
                3: "Medie",
                4: "Plăcut",
                5: "Foarte mult",
            },
            worry: {
                1: "Nu sunt îngrijorat",
                2: "Puțin îngrijorat",
                3: "Îngrijorat",
                4: "Foarte îngrijorat",
                5: "Sigur că mă voi strica în orice moment",
            },
        },
        verdicts: {
            KEEP: "Financiar rezonabil să păstrezi",
            borderline: "Limita – monitorizează îndeaproape",
            sell: "Risc financiar ridicat – vânzarea poate fi rațională",
        },
        factors: {
            trendInc: "Trend Crescător",
            trendIncDesc: "Costurile de reparație cresc comparativ cu anul trecut.",
            lowDepreciation: "Avantaj de Depreciere Mică",
            lowDepreciationDesc: "Mașinile mai vechi/mai ieftine își pierd mai puțină valoare în timp.",
            stableRepairs: "Reparații Stabil",
            stableRepairsDesc: "Costurile tale de reparație sunt stabile sau în scădere.",
            noHistoricalData: "Nu există date mai vechi de 6 luni.",
            lifecycle_stage: "Etapa ciclului de viață al vehiculului",
            high_risk_phase: "Fază de risc ridicat",
            high_risk_phase_desc: "Combinația dintre o etapă tardivă a ciclului de viață și costurile de reparație în creștere indică un risc ridicat.",
            lowCostKm: "Cost Eficient pe KM",
            lowCostKmDesc: "Eficiența generală a funcționării acestei mașini este excelentă.",
            lowFixedCosts: "Costuri Fixe Mici",
            lowFixedCostsDesc: "Costurile tale fixe (impozite, asigurare) sunt mici.",
            usage: "Utilizare Anuală",
            usageDesc: "Distanța parcursă în ultimele 12 luni.",
            accidentMinor: "Accident Minor",
            accidentMinorDesc: "Deteriorări cosmetice sau reparații mici.",
            structuralDamage: "Deteriorare Structurală",
            structuralDamageDesc: "Problemele de cadru sau structurale reduc drastic valoarea.",
            aiLifespanNearEnd: "Sfârșitul Duratei de Viață Așteptate",
            aiLifespanAging: "Componente Îmbătrânite",
            aiLifespanGood: "Avantaj de Kilometraj Mic",
            aiLifespanDesc: "Bazat pe estimarea AI a duratei de viață tipice pentru acest model.",
            aiUpcomingRepairs: "Reparații Viitoare (Predicție AI)",
            aiUpcomingRepairsDesc: "AI prezice defecțiuni majore ale componentelor în curând, pe baza kilometrajului.",
            ownershipFatigue: "Oboseala Proprietății",
            ownershipFatigueLong: "Proprietatea pe termen lung duce adesea la o pregătire mentală pentru un vehicul diferit.",
            ownershipFatigueShort: "Biasul inițial de proprietate creează o tendință mai puternică de a păstra mașina.",
            family_priority: "Familie & Călătorii Lungi",
            replacement_comparison: "Compararea Înlocuirii",
            none: "Niciunul",
            surface: "Suprafață",
            minor: "Minor",
            moderate: "Moderat",
            severe: "Sever",
            structural: "Structural",
            major: "Major",
            critical: "Critic",
            full: "Complet",
            improveLabel: "Ce ar îmbunătăți acest lucru:",
            info_original_price: "Prețul aproximativ al acestei mașini când era nouă. Ajută la estimarea stabilității valorii. Mașinile mai vechi cu o valoare rămasă mai mică sunt mai sigure din punct de vedere financiar.",
            info_current_value: "Cât ai putea să o vinzi astăzi. Folosit pentru a verifica dacă reparațiile reprezintă un procent mare din valoarea mașinii, ceea ce semnalează o investiție proastă.",
            info_yearly_mileage: "Kilometrajul mai mare crește uzura. Kilometrajul scăzut poate extinde semnificativ durata de viață a mașinii.",
            info_estimated_repairs: "Costul continuu de a menține mașina în funcțiune. Costurile anuale mari reduc atractivitatea de a păstra mașina.",
            info_planned_repairs: "Reparații cunoscute care urmează. Simulează presiunea imediată asupra deciziei tale.",
            info_ownership_years: "De cât timp deții această mașină? Acest lucru afectează oboseala psihologică a proprietății și prejudecata inițială a cumpărătorului.",
            info_rust: "Riscul critic pe termen lung. Rugina structurală reduce siguranța. Rugina severă face vânzarea o opțiune mai bună.",
            info_crashes: "Accidentele structurale afectează siguranța și fiabilitatea. De asemenea, reduc semnificativ valoarea de revânzare.",
            info_repaint: "Semnalează daune anterioare sau reparații cosmetice. Impact mic, cu excepția cazului în care problemele mai profunde au fost ascunse.",
            info_unresolved: "Costuri viitoare ascunse. Defecte cunoscute în electronică, motor sau întreținere care necesită atenție.",
            info_fit: "Se potrivește mașina nevoilor tale (spațiu, confort)? O potrivire slabă înseamnă că ești mai predispus să o înlocuiești.",
            info_joy: "Valoarea emoțională contează. Fără bucurie înseamnă că ești mental pregătit pentru o mașină nouă.",
            info_worry: "Stresul perceput al fiabilității. Îngrijorarea mare este un semnal puternic pentru a înlocui mașina.",
        },
        explanations: {
            repairFreq: "Mașina ta a avut {visits} vizite la service în ultimele 12 luni. Vizitele frecvente indică o fiabilitate mai scăzută și mai multe neplăceri.",
            repairVsValue: "În ultimele 12 luni, reparațiile tale au costat €{cost}, în timp ce valoarea estimată a mașinii este de €{value}. Asta reprezintă {ratio}% din valoarea totală a mașinii.",
            stableRepairsDetailYearly: "Anul trecut ai cheltuit €{cost1} pentru reparații, dar anul anterior €{cost2}. Schimbare de {percent}% ({trend}).",
            stableRepairsDetailHalfYearly: "În ultimele 6 luni ai cheltuit €{cost1}, în ultimele 6 luni anterioare €{cost2}. Schimbare de {percent}% ({trend}).",
            mileage: "La {mileage} km, mașina intră într-o zonă de risc mai mare pentru defecțiuni majore ale componentelor (transmisie, componente ale motorului).",
            planned: "Ai €{cost} în reparații planificate, ceea ce reduce imediat siguranța financiară a păstrării mașinii.",
            lowDep: "Mașinile evaluate în jur de €{value} își pierd foarte puțină valoare pe an, compensând costurile mai mari de reparație.",
            depRisk: "Mașina ta are {age} ani și a finalizat în mare parte ciclul de depreciere, ceea ce înseamnă că nu pierzi bani din cauza scăderii valorii.",
            stable: "Ai cheltuit €{costThisYear} în acest an față de €{costLastYear} anul trecut, ceea ce reprezintă o scădere de {percent}%. Costurile previzibile sunt matematic favorabile.",
            costKm: "Ai parcurs {km} km anul trecut. Costurile de funcționare au fost de €{costKm} pe kilometru, ceea ce arată o eficiență economică excelentă.",
            fixedCosts: "Ai plătit €{costs} în costuri fixe anuale (asigurare/impozit). Această amprentă mică oferă o liniște suplimentară.",
            usage: "Conduci aproximativ {km} km pe an, pe baza jurnalelor tale.",
            practical_fit: "Ai evaluat potrivirea practică la {score}/5, ajustând scorul matematic cu {impact} puncte.",
            emotional_satisfaction: "Ai evaluat satisfacția emoțională la {score}/5, ajustând scorul cu {impact} puncte.",
            reliability_anxiety: "Încrederea ta în fiabilitate este {score}/5, influențând scorul cu {impact} puncte.",
            rust: "Rugină structurală severă sau rugină pe partea inferioară înseamnă de obicei riscuri de siguranță sau scenarii de daune totale.",
            accident: "Deteriorările anterioare, în funcție de severitate, reduc în mod inerent valoarea de revânzare și siguranța vehiculului.",
            structural: "Problemele structurale fac ca mașina să devină financiar periculoasă.",
            ai_lifespan: "La {current} km, mașina a completat {ratio}% din durata de viață estimată de AI ({expect} km).",
            ai_repairs: "Datele AI indică faptul că {count} reparații majore specifice modelului tind să apară la acest kilometraj.",
            lifecycle_stage: "Ce înseamnă durata de viață? {total} km – acesta este punctul prezis de AI când reparațiile structurale majore (motor, cutie de viteze etc.) încep de obicei pentru acest model. Nu este sfârșitul vieții mașinii – mașina poate încă să conducă, dar cu costuri de întreținere semnificativ mai mari. Durata de viață fizică completă a unei mașini tipice este de 500k–1M km, dar devine economic neviabilă mult mai devreme.",
        },
        ratios: {
            healthy: "Sănătos",
            monitor: "Monitorizare",
            highRisk: "Risc ridicat",
            stable: "Stabil",
            warning: "Avertisment",
            financialStress: "Stres financiar",
        },
        proFeatureTitle: "Funcție Pro: Mod de Reparație",
        proFeatureDesc: "Dezvăluie motorul de decizie pentru a obține o analiză financiară profesională a reparațiilor vehiculului tău. Utilizatorii gratuiti văd o demonstrație cu date de exemplu.",
        viewDemo: "Vizualizează Demonstrația Live",
        upgradeToUnlock: "Upgradează la PRO pentru a analiza mașina ta",
    },
    carTasks: {
        title: "Sarcini pentru Mașină",
        placeholderTitle: "Urmărirea Întreținerii",
        placeholderDesc: "Programul de întreținere pentru modelul dumneavoastră de mașină.",
        demoTitle: "Sarcini de Întreținere a Mașinii",
        demoSubtitle: "Urmărire inteligentă pentru vehiculul dumneavoastră",
        feature1Title: "Generare Automată a Sarcinilor",
        feature1Desc: "Generează automat sarcini precum schimbarea uleiului, înlocuirea filtrului și verificarea curelei de distribuție pe baza modelului mașinii dumneavoastră.",
        feature2Title: "Integrarea Cheltuielilor",
        feature2Desc: "Analizează istoricul serviciilor pentru a înțelege ce a fost deja făcut și când.",
        feature3Title: "Memento-uri Inteligente",
        feature3Desc: "Primiți notificări pe baza timpului și a kilometrajului. Urmărirea se resetează automat când marcați o sarcină ca fiind finalizată.",
        getStarted: "Începeți",
        fakeDoorPopupTitle: "Feedback Binevenit",
        fakeDoorPopupMessage: "În prezent, dezvoltăm sarcinile de întreținere a mașinii. Această funcție vă va permite să urmăriți automat intervalele de serviciu. Ce sarcini sau funcții specifice ați dori să vedeți cel mai mult?",
        fakeDoorPopupPlaceholder: "Gândurile dumneavoastră...",
        noTasksYet: "Încă nu sunt sarcini",
        deleteAllTitle: "Șterge lista de sarcini?",
        deleteAllMessage: "Ești sigur că vrei să ștergi toate cele {count} sarcini pentru această mașină? Această acțiune nu poate fi anulată.",
        deleteAllSuccess: "Toate sarcinile au fost șterse cu succes.",
        sortPriority: "Prioritate",
        sortType: "Tip",
        sortDate: "Cele mai recente",
        status: {
            overdue: "ÎN ÎNTÂRZIERE",
            pending: "ÎN AȘTEPTARE",
            noData: "FĂRĂ DATE",
            upcoming: "Următoare",
            nextIn: "Următoarea în {dist} {unit}",
            overdueBy: "{dist} {unit} întârziere",
            afterDays: "În {days} zile",
            overdueDays: "{days} zile întârziere",
        },
        form: {
            newTitle: "Sarcină Nouă",
            actionType: "Inspectare sau Înlocuire?",
            intervalMonths: "Interval (Luni)",
            intervalDistance: "Interval (Distanță)",
            diffFirstInterval: "Primul interval diferă de intervalul de bază",
            firstInterval: "Primul Interval",
            historyToggle: "A fost vreodată efectuată această sarcină pentru această mașină?",
            historyToggleDesc: "Dacă NU, presupunem că nu a fost niciodată efectuată de la producție.",
            lastPerformedOptional: "Când a fost efectuată ultima dată? (Opțional)",
            deleteTitle: "Șterge Sarcina",
            deleteConfirm: "Ești sigur că vrei să ștergi această sarcină?",
            saveError: "Nu s-a reușit salvarea sarcinii",
            historyConfirmed: "Istoricul Confirmat",
            reminders: "Memento",
            notifyMileage: "Notifică-mă când se atinge kilometrajul estimat",
            notifyDate: "Notifică-mă când se atinge data",
            nextMileageReminder: "Data estimată",
            nextDateReminder: "Data limită",
            estimatedDate: "Data estimată",
            missingLastMileage: "Lipsă ultima distanță parcursă",
            missingLastDate: "Lipsă ultima dată efectuată",
            missingStartDate: "Nu s-a putut determina data de început",
            additionalOptions: "Opțiuni suplimentare",
            reminderInfoMissing: "Stare informativă: mementourile sunt dezactivate până când sunt furnizate datele ultimei acțiuni efectuate.",
        },
    },
    dashboard: {
        title: "Tabloul de Bord",
        quickActions: "Acțiuni Rapide",
        addExpense: "Adaugă Cheltuială",
        editCar: "Editează Mașina",
        recentExpenses: "Cheltuieli",
        seeAll: "Vezi Tot",
        recentGallery: "Fișiere",
        thisMonth: "Luna Aceasta",
        totalSpent: "Total Cheltuit",
        avgPerMonth: "Medie/Lună",
        recentNotes: "Note",
        recentParts: "Piese",
        noRecentExpenses: "Nu sunt cheltuieli recente",
        noRecentGallery: "Nu sunt fotografii recente",
        noRecentNotes: "Nu sunt note recente",
        noRecentParts: "Nu sunt piese recente",
        createNote: "Creează Nou",
        createPart: "Creează Nou",
        createExpense: "Creează Nou",
        noFiles: "Nu au fost adăugate fișiere încă",
        needSomethingMore: "Ai nevoie de ceva mai mult?",
        letUsKnow: "anunță-ne!",
    },
    expenseTypes: {
        editTitle: "Editează Tipul de Cheltuială",
        newTitle: "Tip Nou de Cheltuială",
        categoryName: "Numele Categoriei",
        placeholderName: "de exemplu. Serviciu",
        signatureColor: "Culoarea Semnăturii",
        icon: "Iconița Categoriei",
        deleteConfirm: "Ești sigur că vrei să ștergi tipul '{name}'?",
    },
    spareParts: {
        title: "Piese de Schimb",
        connectedWithRecords: "Conectat cu Înregistrări",
        toBuy: "De Cumpărat",
        usedInExpenses: "Folosite în Cheltuieli",
        noPartsToBuy: "Nu sunt piese adăugate pe lista de cumpărături",
        noPartsUsed: "Nu sunt piese legate de cheltuieli încă",
        quantity: "Cant.",
        partCode: "Cod Piesă",
        price: "Preț",
        link: "Link",
        comment: "Comentariu",
        addPart: "Adaugă Piesă de Schimb",
        editPart: "Editează Piesă de Schimb",
        openPart: "Deschide înregistrarea Piesei",
        nameLabel: "Nume",
        manufacturerLabel: "Producător",
        priceLabel: "Preț ({currency})",
        imagesLabel: "Fișiere",
        linkedHistory: "Istoric Legat",
        partManagedNote: "Această piesă este gestionată printr-o cheltuială",
        cannotDeleteNote: "Deoarece această piesă este legată de o cheltuială, nu poate fi ștearsă separat. Șterge sau editează cheltuiala pentru a gestiona ciclul de viață al acestei piese.",
        partNamePlaceholder: "Numele piesei...",
        manufacturerPlaceholder: "Bosch, Brembo, etc.",
        additionalInfoPlaceholder: "Informații suplimentare...",
        namePlaceholder: "de exemplu. Plăcuțe de Frână",
        codePlaceholder: "de exemplu. 5Q0 698 151",
        linkPlaceholder: "https://...",
        vinPlaceholder: "WBADT...",
        savePart: "Salvează Piesa",
        deletePart: "Șterge piesa de schimb",
        deleteConfirm: "Ești sigur că vrei să ștergi această piesă de schimb?",
        sparePartsLabel: "Piese de Schimb",
        partNumber: "Piesa #{number}",
        imagesLimitLabel: "Fișiere (maxim 5)",
        optional: "(opțional)",
        selectPart: "Selectează Piesa de Schimb",
        createNew: "Creează o nouă piesă de schimb",
        searchPlaceholder: "Caută după nume sau cod...",
        noResults: "Nu au fost găsite piese",
        noPartsYet: "Nu sunt piese încă. Creează prima ta!",
        selectorDescription: "Găsește și selectează o piesă de schimb existentă sau creează una nouă",
        alreadyAdded: "Această piesă este deja adăugată",
        statistics: {
            avgPrice: "Medie",
            lastPrice: "Ultimul",
            usedTimes: "Folosite {count} ori",
            totalPurchased: "Total: {quantity}x",
        },
        usage: {
            title: "Această Achiziție",
            quantity: "Cantitate",
            pricePerUnit: "Preț pe unitate",
            comment: "Comentariu",
            commentPlaceholder: "de exemplu., Cumpărat de la AutoZone",
            total: "Total",
            transactionData: "Această tranzacție",
        },
        masterData: "Informații principale despre piesă",
        masterRecord: {
            title: "Detalii Piesă (partajate)",
            editMaster: "Editează Înregistrarea Principală",
            warning: "Modificările înregistrării principale afectează toate utilizările",
        },
    },
    reminders: {
        title: "Mementouri",
        reminder: "Memento",
        noteReminder: "Memento Notă",
        partReminder: "Memento Parte",
        today: "Astăzi",
        tomorrow: "Mâine",
        yesterday: "Ieri",
        inXDays: "în {x} zile",
        xDaysAgo: "acum {x} zile",
        inXMonths: "în {x} luni",
        xMonthsAgo: "acum {x} luni",
        active: "Activ",
        activeDesc: "Dacă este necesar, poți dezactiva acest memento fără a-l șterge",
        disabled: "Dezactivat",
        yearly: "Anual",
        markSeen: "Confirmă",
        addReminder: "Memento Nou",
        editReminder: "Editează Memento",
        extraReminders: "Mementouri Extra",
        extraRemindersDesc: "Trimite 3 mementouri suplimentare în zilele următoare (4 în total) dacă nu sunt oprite.",
        remindDate: "Dată",
        remindTime: "Timp",
        repeatYearly: "Repetă Anual",
        repeatYearlyDesc: "Acest memento va avea loc automat în fiecare an în aceeași dată/lună/zi/timp până când va fi dezactivat",
        standalone: "Mementouri Independente",
        embedded: "Mementouri Legate",
        noReminders: "Nu există mementouri active",
        deleteReminder: "Șterge Memento",
        nameLabel: "Nume",
        descriptionLabel: "Descriere",
        namePlaceholder: "Numele memento-ului",
        descriptionPlaceholder: "Descriere scurtă sau notă",
        simulateReminder: "Simulează momentul memento-ului",
        simulateSuccess: "Email de simulare trimis",
        timezone: "Fus orar",
        nextReminder: "Următorul memento",
        futureTimeError: "Timpul pentru memento trebuie să fie în viitor",
    },
    notes: {
        title: "Note",
        emptyNote: "Notă goală",
        noNotes: "Nu sunt note încă",
        addNote: "Adaugă Notă",
        editNote: "Editează Notă",
        viewNote: "Vizualizează Notă",
        openNote: "Deschide înregistrarea Notei",
        titleLabel: "Titlu",
        contentLabel: "Conținut",
        noteTitlePlaceholder: "Titlul notei...",
        noteContentPlaceholder: "Scrieți nota aici...",
        saveNote: "Salvează nota",
        deleteNote: "Șterge nota",
        publicNote: "Fă nota publică",
        publicNoteDesc: "Alții pot vizualiza această notă prin linkul partajat",
        deleteConfirm: "Ești sigur că vrei să ștergi această notă?",
        enterTitleAlert: "Te rugăm să introduci un titlu",
        saveFailed: "Salvarea notei a eșuat",
        thisNote: "Această notă",
        deleteFailed: "Ștergerea notei a eșuat",
        pinToTop: "Fixează în partea de sus",
    },
    locations: {
        title: "Locații",
        singleTitle: "Locație",
        newLocation: "Locație nouă",
        emptyLocation: "Locație goală",
        noLocations: "Pentru statistici - poți adăuga locația unde a avut loc această cheltuială auto",
        addLocation: "Adaugă locație",
        editLocation: "Editează locația",
        viewLocation: "Vizualizează locația",
        openLocation: "Deschide locația",
        createNew: "Creează locație nouă",
        selectLocation: "Selectează locația",
        searchLocations: "Caută locații...",
        nameLabel: "Nume",
        addressLabel: "Adresă sau coordonate",
        descriptionLabel: "Comentariu/Descriere",
        namePlaceholder: "de ex., Serviciu în centru",
        mapLabel: "Locație",
        searchPlaceholder: "Caută adresă...",
        addressPlaceholder: "Introdu adresa și selectează...",
        descriptionPlaceholder: "Informații suplimentare...",
        fillAddress: "Completează adresa din hartă",
        saveLocation: "Salvează locația",
        deleteLocation: "Șterge locația",
        deleteConfirm: "Ești sigur că vrei să ștergi această locație?",
        enterNameAlert: "Te rugăm să introduci un nume",
        saveFailed: "Salvarea locației a eșuat",
        thisLocation: "Această locație",
        deleteFailed: "Ștergerea locației a eșuat",
        myLocations: "Locațiile mele",
        usedInEntries: "Folosite în înregistrări",
        noEntries: "Locația nu este folosită",
        noEntriesThisCar: "Această locație nu a fost folosită pentru această mașină",
        removeLocation: "Elimină locația",
        noResults: "Nu s-au găsit rezultate",
    },
    gallery: {
        title: "Fișiere",
        noImages: "Nu au fost adăugate imagini",
        addImagesNote: "Adaugă imagini pentru mașină sau cheltuieli",
        totalImages: "Total {count} imagini",
        imageAlt: "Imagine {number}",
        commentPlaceholder: "Comentariu fișier",
        isReceipt: "Acest fișier este o chitanță",
        deleteImageTitle: "Șterge fișierul",
        deleteImageConfirm: "Ești sigur că vrei să ștergi permanent acest fișier?",
    },
    search: {
        placeholder: "Caută cheltuieli, piese, note...",
        typeToSearch: "Scrie pentru a începe căutarea",
        noResults: "Nu s-au găsit rezultate pentru '{query}'",
        carImage: "Imagine mașină",
        expenseImage: "Imagine cheltuială",
        noteImage: "Imagine notă",
        galleryImage: "Imagine galerie",
        untitledExpense: "Cheltuială fără titlu",
    },
    landing: {
        nav: {
            features: "Funcționalități",
            howItWorks: "Cum funcționează",
            pricing: "Prețuri",
            login: "Conectează-te",
            getStarted: "Începe",
            garage: "Garaj",
        },
        hero: {
            title: "Știți exact ce costă mașina dumneavoastră",
            subtitle: "Cu adevărat",
            description: "Urmăriți cheltuielile, înregistrați reparațiile și vedeți unde se duc cu adevărat banii dumneavoastră.",
            subheadline: "Panoul de control profesional bazat pe date pentru proprietarii de mașini meticuloși.",
            startTracking: "Începe",
            viewDemo: "Demo Auto ->",
            trustSignal: "Alătură-te celor peste 1,200 de proprietari meticuloși care au cartografiat deja peste 5 milioane de kilometri de costuri reale ale mașinilor.",
            ctaNote: "Fără card de credit. Fără vânzări insistente. Doar claritate.",
            benefits: {
                repairVsSell: {
                    title: `Reparație vs. Vânzare`,
                    description: `Identifică pragul "Reparație vs. Vânzare" — Nu mai întreba dacă arunci bani într-o gaură financiară. Știu exact momentul în care o reparație nu mai este o investiție inteligentă.`
                },
                costPerKm: {
                    title: `Cost pe KM`,
                    description: `Urmărește costul tău real pe kilometru — Mergi dincolo de panoul de control. Vezi întreaga imagine financiară a obiceiurilor tale de conducere pe care alte aplicații le omit.`
                },
                automation: {
                    title: `Automatizare`,
                    description: `Automatizează-ți păstrarea înregistrărilor — Trimite pur și simplu facturile tale sau trimite prin email notițele tale. AI-ul nostru îți organizează istoricul tehnic al mașinii.`
                }
            },
        },
        features: {
            title: "Tot ce ai nevoie pentru a-ți gestiona mașina",
            subtitle: "Oprește-te din utilizarea foilor de calcul și a folderelor dezordonate. My Car Costs aduce instrumente profesionale de gestionare a flotei în garajul tău personal.",
            expenseTracking: {
                title: "Urmărirea cheltuielilor",
                description: "Înregistrează combustibilul, serviciile, asigurările și reparațiile. Categorizează costurile și vizualizează tendințele de cheltuieli în timp.",
            },
            spareParts: {
                title: "Manager de piese de schimb",
                description: "Păstrează un inventar detaliat al pieselor de schimb, numerelor de piese și notelor de compatibilitate pentru toate reparațiile tale.",
            },
            serviceHistory: {
                title: "Istoricul serviciilor și note",
                description: "Menține un carnet de service digital. Adaugă note detaliate despre întreținere, modificări sau planuri viitoare.",
            },
            documentStorage: {
                title: "Stocare documente",
                description: "Încarcă chitanțe, facturi și fotografii ale mașinii tale. Păstrează toată documentația ta în siguranță și accesibilă.",
            },
            emailForwarding: {
                title: "Redirecționare email",
                description: "Redirecționează facturile direct către inboxul tău unic. Vom extrage datele și le vom adăuga automat în tabloul tău de bord.",
            },
            multiCar: {
                title: "Garaj multi-mașini",
                description: "Gestionează o mașină sau o întreagă flotă. Comută instantaneu între vehicule și vezi statistici agregate.",
            },
            repeatingExpenses: {
                title: "Cheltuieli Repetate",
                description: "Automatizează urmărirea costurilor lunare regulate, cum ar fi asigurarea, parcarea sau leasingul.",
            },
            smartReminders: {
                title: "Memento-uri Inteligente",
                description: "Setează alerte personalizate pentru piese de schimb și note de service pentru a nu rata niciodată o sarcină de întreținere.",
            },
        },
        howItWorks: {
            title: "Flux de lucru simplu și puternic",
            step1: {
                title: "Adaugă vehiculul tău",
                description: "Introdu detaliile mașinii tale pentru a crea garajul tău digital.",
            },
            step2: {
                title: "Înregistrează cheltuieli și fișiere",
                description: "Fă o fotografie a unei chitanțe sau redirecționează un email. Ne ocupăm de restul.",
            },
            step3: {
                title: "Obține informații",
                description: "Vezi costul pe kilometru, cheltuielile lunare și cronologia întreținerii.",
            },
        },
        useCases: {
            title: "Perfect pentru",
            enthusiasts: {
                title: "Entuziaștii auto",
                description: "Urmărește fiecare modificare, număr de piesă și interval de întreținere pentru mașina ta de proiect.",
            },
            dailyDrivers: {
                title: "Șoferi zilnici",
                description: "Știi exact cât costă naveta ta și nu rata niciodată o dată de service.",
            },
            flippers: {
                title: "Flipperul Inteligent",
                description: "Construiește un volum verificabil de date care dovedește adevărata valoare a mașinii tale pentru cumpărători.",
            },
            fleets: {
                title: "Flote mici",
                description: "Gestionează mai multe vehicule de companie într-un singur loc fără a avea un software de întreprindere complicat.",
            },
        },
        foundersNote: {
            title: "Nota Fondatorului",
            content: "Construiesc MyCarCosts pentru a fi instrumentul suprem pentru persoanele care chiar le pasă de mașinile lor. Există o funcție lipsă din fluxul tău de lucru? Contactează-mă direct. Dacă are sens pentru comunitate, o vom construi împreună.",
        },
        pricing: {
            freeLimitedTime: "Gratuit pentru un timp limitat",
            title: "Prețuri simple și transparente",
            subtitle: "Începeți gratuit, faceți upgrade pe măsură ce creșteți.",
            perMonth: "lună",
            monthly: "Lunar",
            yearly: "Anual",
            save25: "Economisește 25%",
            billedAnnually: "Facturat anual ({amount})",
            free: {
                title: "Gratuit",
                cta: "Începeți",
            },
            pro: {
                title: "Pro",
                cta: "Faceți upgrade la Pro",
                recommended: "Recomandat",
                earlyAdopter: "Preț pentru adoptatori timpurii",
                priceLock: "Blocați acest preț acum. Prețul poate crește în viitor.",
            },
            custom: {
                title: "Custom",
                cta: "Contactați-ne",
            },
            features: {
                oneCar: "1 mașină",
                unlimitedExpenses: "Cheltuieli nelimitate",
                unlimitedSpareParts: "Piese de schimb nelimitate",
                unlimitedNotes: "Note nelimitate",
                repeatedExpenses: "Cheltuieli repetate",
                emailReminders: "Memento-uri prin email pentru note și piese de schimb",
                basicStatistics: "Statistici de bază",
                fullStatistics: "Statistici complete",
                storage50mb: "Stocare fișiere de 50 Mb",
                unlimitedArchivedCars: "Mașini arhivate nelimitat",
                dataExport: "Export de date",
                allInFreePlus: "toate în free plus:",
                threeCars: "Până la 3 mașini",
                storage2gb: "Stocare fișiere de 2 Gb",
                emailParsing: "Analiza emailurilor",
                carAdmins: "Administratori auto",
                moreCars: "Mai multe mașini",
                moreFileStorage: "Mai multă stocare pentru fișiere",
                customRequirements: "Cerințe personalizate",
            },
            upgradePopup: {
                title: "În curând!",
                message: "Versiunile pro și personalizate nu sunt încă lansate, dar vor fi în curând. Pentru a ne ajuta să lansăm mai repede - te rugăm să notezi ce caracteristică specifică aștepți de la versiunea pro / personalizată sau orice altceva ai dori să îmbunătățim pentru a face această platformă și mai bună pentru tine!",
                placeholder: "Scrie feedback-ul tău aici...",
                submit: "Trimite",
                cancel: "Anulează",
                thanksTitle: "Mulțumim!",
                thanksMessage: "Am primit feedback-ul tău și vom lucra pentru a face MyCarCosts și mai bun!",
                thanksOk: "Ok",
            },
        },
        migration: {
            title: "Trecerea de la Excel sau altă aplicație?",
            subtitle: "Oferim un serviciu profesional de migrare a datelor pentru a vă pune în funcțiune instantaneu.",
            pricingModel: "Model de preț",
            small: {
                title: "Set de date mic",
                description: "< 500 rânduri",
                price: "$19–29",
            },
            medium: {
                title: "Set de date mediu",
                description: "500–5,000 rânduri",
                price: "$49",
            },
            large: {
                title: "Mare / Haotic",
                description: "Sisteme vechi sau fișiere complexe",
                price: "Cotație personalizată",
            },
            process: {
                title: "Cum funcționează",
                step1: "Trimiteți fișierul dvs.",
                step2: "Evaluăm datele",
                step3: "Plată unică",
                step4: "Ne ocupăm de import",
            },
            cta: "Solicitați Migrarea",
        },
        repairAnalysisSection: {
            title: "Reparare sau Vânzare? Lăsați datele să decidă.",
            subtitle: "Analiză financiară profesională pentru vehiculul dvs. Opriți ghicitul și începeți să știți dacă acele reparații merită cu adevărat.",
            features: {
                personalized: {
                    title: "Analiză Personalizată",
                    description: "Pentru mașinile tale urmărite, folosim cheltuieli și parametri istorici reali, adăugând costuri planificate pentru a genera o evaluare.",
                },
                public: {
                    title: "Simulator Public",
                    description: "Evaluezi o achiziție potențială? Folosește instrumentul nostru public la /repair pentru a genera o analiză detaliată introducând doar câteva detalii cheie.",
                },
                whatIf: {
                    title: "Simulator Ce-ar fi",
                    description: "Introduceți un cost de reparație planificat și vedeți instantaneu cum afectează scorul financiar al mașinii dvs.",
                },
            },
            cta: "Vizualizați Analiza Exemplu",
        },
        faq: {
            title: "Întrebări Frecvente",
            subtitle: "Tot ce trebuie să știți despre Cheltuielile Mașinii Mele",
            questions: {
                mobileApps: {
                    question: "Vor exista aplicații iOS și Android?",
                    answer: "Da! Aplicațiile mobile pentru iOS și Android vor veni în curând. Lucrăm din greu pentru a vă oferi cea mai bună experiență mobilă.",
                },
                dataPrivacy: {
                    question: "Datele mele sunt private și sigure?",
                    answer: "Absolut. Datele dvs. sunt criptate și stocate în siguranță. Numai dvs. puteți accesa informațiile despre mașina dvs. decât dacă alegeți explicit să le faceți publice.",
                },
                freePlan: {
                    question: "Planul gratuit este cu adevărat gratuit pentru totdeauna?",
                    answer: "Da! Planul gratuit va fi întotdeauna disponibil pentru o mașină și toate funcțiile esențiale. Puteți face upgrade la Pro oricând pentru până la 3 mașini și funcții avansate.",
                },
                dataExport: {
                    question: "Pot exporta datele mele?",
                    answer: "Da, puteți exporta toate datele dvs. în orice moment în format CSV sau PDF. Datele dvs. sunt ale dvs. și nu sunteți niciodată blocați.",
                },
                emailImport: {
                    question: "Cum funcționează importul de email?",
                    answer: "Fiecare mașină primește o adresă de email unică. Doar redirecționați facturile dvs. și vom extrage datele automat.",
                },
                multipleUsers: {
                    question: "Pot mai multe persoane să acceseze aceeași mașină?",
                    answer: "În prezent, fiecare mașină aparține unui singur cont. Cu toate acestea, puteți face o mașină vizibilă public pentru a partaja accesul doar la citire cu alții.",
                },
            },
        },
        cta: {
            title: "Nu mai ghici. Începe să știi.",
            subtitle: "Transformă istoricul mașinii tale în decizii financiare clare. Alătură-te miilor de proprietari inteligenți care știu exact când să investească sau să vândă.",
            button: "Începe acum",
            note: "Fără card de credit. Fără vânzări insistente. Doar claritate.",
        },
        footer: {
            product: "Produs",
            legal: "Legal",
            changelog: "Jurnal de modificări",
            privacy: "Politica de confidențialitate",
            contact: "Contact",
            contactEmail: "info@mycarcosts.com",
            questions: "Aveți întrebări? Contactați-ne la:",
        },
        privacy: {
            title: "Politica de confidențialitate",
            lastUpdated: "Ultima actualizare: 25 martie 2026",
            introduction: "La My Car Costs, luăm în serios confidențialitatea dvs. Această politică explică modul în care gestionăm datele dvs. în conformitate cu standardele moderne de confidențialitate, inclusiv GDPR.",
            dataCollection: {
                title: "Colectarea datelor",
                description: "Colectăm doar minimul absolut de informații necesare pentru a furniza serviciul nostru.",
                email: "Identitatea contului: Utilizăm adresa dvs. de e-mail ca identificator unic și pentru autentificare (de exemplu, linkuri magice sau conectare Google).",
                documents: "Stocarea documentelor: Fișierele pe care le încărcați sunt stocate în siguranță într-un spațiu de stocare în cloud criptat.",
            },
            carData: {
                title: "Controlul datelor dvs.",
                description: "Informațiile pe care le introduceți (cheltuieli, kilometraj, piese) sunt stocate pentru uzul și analiza dvs. personală.",
                noValidation: "Nu validăm datele vehiculului pe care le furnizați; este responsabilitatea dvs. să asigurați acuratețea.",
                privateByDefault: "În mod implicit, datele dvs. sunt private. Identificatorii tehnici ai fișierelor sunt nesecvențiali și nu sunt indexați de motoarele de căutare.",
                rightToForgotten: "Dreptul de a fi uitat: Vă puteți șterge contul în orice moment, ceea ce elimină imediat și permanent toate înregistrările și fișierele dvs.",
            },
            thirdParty: {
                title: "Servicii terțe",
                description: "Nu vindem datele dvs. personale. Când utilizați Google Login, accesăm doar adresa dvs. de e-mail în scopuri de identificare.",
            },
            emailIngestion: {
                title: "Preluarea e-mailurilor",
                description: "E-mailurile trimise către serviciul nostru de preluare sunt stocate pentru a oferi un istoric de procesare. Puteți șterge manual e-mailurile individuale sau întregul istoric în orice moment.",
            },
        },
        emails: {
            deleteAll: "Șterge tot",
            deleteAllConfirm: "Sunteți sigur că doriți să ștergeți întregul istoric de e-mailuri pentru această mașină? Această acțiune este ireversibilă.",
            deleteConfirm: "Sunteți sigur că doriți să ștergeți acest e-mail?",
            noEmails: "Nu s-au primit încă e-mailuri.",
        },
        terms: {
            title: "Termeni și condiții",
            lastUpdated: "Ultima actualizare: 25 martie 2026",
            introduction: "Prin accesarea sau utilizarea MyCarCosts, sunteți de acord să respectați acești Termeni și condiții. Dacă nu sunteți de acord, vă rugăm să nu utilizați serviciul nostru.",
            acceptance: {
                title: "1. Acceptarea termenilor",
                description: "Acești termeni constituie un acord legal obligatoriu între dvs. și MyCarCosts cu privire la utilizarea aplicației și serviciilor noastre.",
            },
            service: {
                title: "2. Descrierea serviciului",
                description: "MyCarCosts oferă o platformă pentru urmărirea cheltuielilor vehiculelor, gestionarea întreținerii și analiza financiară. Aceasta include analiza chitanțelor asistată de AI și instrumente de vizualizare a datelor.",
            },
            responsibilities: {
                title: "3. Responsabilitățile utilizatorului",
                description: "Sunteți responsabil pentru acuratețea tuturor datelor pe care le introduceți, inclusiv kilometrajul, numerele VIN și costurile. Trebuie să vă păstrați datele de autentificare (e-mail/magic link) în siguranță și să nu le partajați cu părți neautorizate.",
            },
            plans: {
                title: "4. Planuri de servicii și limite",
                description: "Oferim planuri Free și Pro cu limite diferite de stocare, număr de mașini și încărcări. Ne rezervăm dreptul de a modifica aceste limite sau de a introduce noi niveluri de abonament în orice moment.",
            },
            disclaimer: {
                title: "5. Excluderea responsabilității și acuratețea",
                description: "MyCarCosts este un instrument informațional și organizațional. Nu oferim certificări oficiale ale stării vehiculului. Datele din chitanțe analizate de AI ar trebui verificate întotdeauna de utilizator pentru acuratețe.",
            },
            liability: {
                title: "6. Limitarea răspunderii",
                description: "MyCarCosts este furnizat 'ca atare'. Nu suntem responsabili pentru nicio problemă mecanică, pierdere financiară sau inexactitate a datelor rezultată din utilizarea aplicației noastre.",
            },
            termination: {
                title: "7. Rezilierea",
                description: "Puteți înceta utilizarea serviciului și vă puteți șterge datele în orice moment. Ne rezervăm dreptul de a suspenda sau închide conturile care încalcă acești termeni sau prezintă comportament abuziv.",
            },
        },
    },
            audit: {
        hero: {
            badge: 'New: Protection Tool',
            title: 'Consult the Oracle.',
            subtitle: 'Stop second-guessing your mechanic. Paste your quote, describe the noise, or upload a photo. Get a direct, logic-based verdict in 60 seconds.',
            cta: 'Consult the Oracle',
            smallPrint: '100% Private. No credit card required.',
            walletSecurity: 'AI-Powered Security for Your Wallet'
        },
        demo: {
            title: 'Audit Results',
            verdictSell: 'Verdict: SELL',
            repairVsValue: 'Repair vs Value',
            cashGapSavings: 'Cash Gap to Replace',
            savingsValue: '$3,200 Savings',
            roiStrategyTitle: 'ROI Strategy',
            roiStrategyText: 'Investing $2,100 into a deteriorating $4,500 asset is a negative ROI. Replacing with a 2018 model now saves you $3,200 in long-term equity.',
            benefitsTitle: 'Stop Guessing. Master Your Car\'s ROI.',
            ctaSubtext: 'Stop guessing. Put your car\'s costs into logic-driven perspective.'
        },
        form: {
            uploadTitle: 'Photos or Documents (Optional)',
            uploadDesc: 'Upload a photo of your quote or just a picture of the problem area.',
            emailLabel: 'Email Address',
            emailPlaceholder: 'Where to send your report?',
            carLabel: 'Car Model',
            carPlaceholder: 'e.g. 2018 BMW X5 TDI 2.0 sedan',
            descLabel: 'Describe the problem',
            descPlaceholder: 'Paste your mechanic quote, describe the noise, or tell us the problem...',
            submit: 'Consult the Oracle',
            submitting: 'Processing...',
            successTitle: 'Quote Received!',
            successDesc: 'Our AI agents are analyzing your data. You will receive a detailed report at {email} within 60 seconds.',
            errorNoFiles: 'Please provide a description or upload a file.',
            errorNoEmail: 'Please enter your email address.',
            verifiedBy: 'Verified by Double-Agent Protocol'
        },
        progress: {
            analyzing: 'Analysis in progress...',
            scanning: 'Scanning Documents',
            checking: 'Checking Market Data',
            roi: 'ROI Calculations',
            finalizing: 'Finalizing Report',
            lightningTitle: 'First Look Verdict',
            lightningBadge: 'LIGHTNING ANALYSIS',
            firstImpression: 'First Impression',
            checkEmail: 'Check your email in 60 seconds',
            anotherAudit: 'Audit Another Situation',
            statusDesc: 'Our Double-Agent system is scrutinizing your data. The final report will be sent to your email.'
        },
        valueProps: {
            negotiation: {
                title: 'ROI Analysis',
                desc: 'Stop overpaying for labor. Get data-backed arguments for real repair times.'
            },
            peace: {
                title: 'Verdict in 60s',
                desc: 'Know for sure if your mechanic is honest about repairs or trying to "bloat" the bill.'
            },
            scams: {
                title: 'Avoid Common Scams',
                desc: 'Our database found that the average quote in big city dealerships is padded by 22% for "consultation" fees that aren\'t necessary.'
            },
            technical: {
                title: 'Replacement Logic',
                desc: 'We calculate the "Cash Gap" — the true cost of fixing your car versus replacing it with something reliable.'
            }
        },
        cta: {
            title: 'Stop dumping cash into a car that isn’t worth it.',
            button: 'Audit the Situation Now'
        },
        howItWorks: {
            title: 'How It Works',
            subtitle: 'The "Double-Agent" verification system ensures you get facts, not fluff.',
            extract: {
                title: 'Data Intake',
                desc: 'We analyze your situation and car model, factoring in mileage and historical maintenance trends.'
            },
            analyze: {
                title: 'Market Analysis',
                desc: 'Our AI compares repair costs against current market valuations and model reliability scores.'
            },
            audit: {
                title: 'ROI Calculation',
                desc: 'We calculate the financial gap between fixing your current vehicle and moving to a better one.'
            },
            verdict: {
                title: 'The Verdict',
                desc: 'You receive a clear "Repair or Sell" report with logic-driven strategy and priority action items.'
            }
        },
        results: {
            priceRealityCheck: 'Price Reality Check',
            roadmapTitle: 'What breaks next?',
            roadmapBadge: 'Roadmap Teaser',
            unlockFullReport: 'Unlock Full Forensic Audit',
            realWorldInsights: 'Real-World Insights',
            oracleAdvice: 'Real Advice from the Oracle',
            oracleAdviceSub: 'See how our AI helps real people navigate complex car problems every day.',
            readFullAudit: 'Read Full Audit',
            potentialSaving: 'Potential Saving',
            getYourOwn: 'Get your own Oracle Audit',
            savingsPotentialFound: 'Savings Potential Found',
            negotiationScript: 'Negotiation Script'
        },
        caseStudy: {
            backToAudit: 'Back to Audit',
            oracleCaseStudy: 'The Oracle Case Study',
            realUserQuestion: 'The Real User Question',
            officialAudit: 'Official Oracle Audit',
            fullReport: 'Full Resolution Report',
            economicImpact: 'Economic Impact',
            startYourAudit: 'Start Your Own Audit',
            moreAudits: 'More Real-World Audits',
            sharingIsCaring: "Sharing is caring. Save someone else's wallet.",
            poweredBy: 'Powered by MyCarCosts Double-Agent Intelligence'
        }
    },
    jarvis: {
        title: 'Jarvis',
        subtitle: 'AI Garage Agent',
        askJarvis: 'Ask Jarvis...',
        typing: 'Jarvis is thinking...',
        safetyWarning: 'Safety Warning',
        repairVerdict: 'Repair Verdict',
        diyFeasibility: 'DIY Feasibility'
    },
    repairMode: {
        oracleStatus: 'Oracle Status: {status}',
        verdictKeep: 'KEEP',
        verdictSell: 'SELL',
        verdictBorderline: 'BORDERLINE'
    }
};

